import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { isBetween } from '@fretadao/f-js-utils';
import { find, addClass, removeClass } from '@fretadao/f-js-dom';

application.register('remote-filter', class extends Controller {
  static targets = ['form', 'paginationLink', 'filterResult', 'loadingIndicator'];
  static values = { skipScrollTo: Boolean, loginUrl: String };

  connect() {
    this.#bindAjaxEventsToForm();
  }

  onFilterSuccess(event) {
    const [response, _status, _xhr] = event.detail;

    this.#refreshScreen(response);
    this.hideLoading()
  }

  onFilterError(event) {
    if (this.#isUnathorizedError()) {
      window.location = this.loginUrlValue;
      return;
    }

    this.#refreshScreen(this.#buildErrorMessage(event));
    this.hideLoading()
  }

  showLoading() {
    if (this.hasLoadingIndicatorTarget) {
      removeClass(this.loadingIndicatorTarget, 'hidden');
    }
  }

  hideLoading() {
    if (this.hasLoadingIndicatorTarget) {
      addClass(this.loadingIndicatorTarget, 'hidden');
    }
  }

  #refreshScreen(content) {
    let response = content;

    if (typeof (content) === 'object') {
      response = find('body', content.documentElement).innerHTML;
    }

    this.filterResultTarget.innerHTML = response;
    this.#bindAjaxEventsToForm();
    if (!this.skipScrollToValue) this.#scrollTo(this.filterResultTarget);
  }

  #bindAjaxEventsToForm() {
    this.formTarget.addEventListener('ajax:success', this.onFilterSuccess.bind(this));
    this.formTarget.addEventListener('ajax:error', this.onFilterError.bind(this));

    this.paginationLinkTargets.forEach(paginationLink => {
      paginationLink.addEventListener('ajax:success', this.onFilterSuccess.bind(this));
      paginationLink.addEventListener('ajax:error', this.onFilterError.bind(this));
    });
  }

  #isUnathorizedError() {
    const [_response, _status, xhr] = event.detail;

    return xhr.status === 401;
  }

  #isServerError(event) {
    const [_response, _status, xhr] = event.detail;

    return isBetween(xhr.status, 500, 599);
  }

  #scrollTo(element) {
    element.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  #buildErrorMessage(event) {
    return `<div class="container text-center md:p-5">
       <p class="bg-gray-ltr text-sm md:text-base font-bold py-10 rounded-md">
         ${this.#errorMessageFor(event)}
       </p>
     </div>`;
  }

  #errorMessageFor(event) {
    if (this.#isServerError(event)) {
      return 'Ocorreu um erro inesperado. Tente novamente mais tarde.';
    } else {
      return 'Não foram encontrados registros!';
    }
  }
});
